import { Component, OnInit } from '@angular/core';

import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';

@Component({
  selector: 'itpx-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.css']
})
export class CommunicationComponent {

  private url: string;
    private detailsRoute: string = '/agora/account-data/communication/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Street Name',
            name: 'streetName',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Country',
            name: 'country',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'State',
            name: 'state'
        }, {
            title: 'Province',
            name: 'province'
        }, {
            title: 'City',
            name: 'city'
        }, {
            title: 'House Number',
            name: 'houseNumber'
        }, {
            title: 'Domain',
            name: 'domain'
        }, {
            title: 'First Name',
            name: 'firstName',
            hidden: true
        }, {
            title: 'Last Name',
            name: 'lastName',
            hidden: true
        }, {
            title: 'Company Name',
            name: 'companyName',
            hidden: true
        }
    ];

    constructor( private configService: ConfigService ) {
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.communication.list.api;
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/communication/communication.component.ts